import { Action, createReducer, on } from '@ngrx/store';
import { LocationModel } from '../../shared/models/location.model';
import * as CentralLocationSelectorActions from '../actions/lobby-central-view-location-selector.actions';

export interface LobbyCentralLocationSelectorState {
    locationData: LocationModel[];
    selectedLocations: LocationModel[];
}

const initialLobbyCentralLocationSelectorState = {
    locationData: [],
    selectedLocations: []
};


const reducer = createReducer<LobbyCentralLocationSelectorState>(
    initialLobbyCentralLocationSelectorState,
    on(CentralLocationSelectorActions.loadCentralLobbyLocationDataSuccess,
        (lobbyCentralLocationSelectorState, action): LobbyCentralLocationSelectorState => (
            {
                ...lobbyCentralLocationSelectorState,
                locationData: action.locationData,
                selectedLocations: lobbyCentralLocationSelectorState.selectedLocations.length === 0 ? action.locationData : lobbyCentralLocationSelectorState.selectedLocations
            }
        )),
    on(CentralLocationSelectorActions.setCentralLocationSelectorItemSelect,
        (lobbyCentralLocationSelectorState, action): LobbyCentralLocationSelectorState => (
            {
                ...lobbyCentralLocationSelectorState,
                selectedLocations: lobbyCentralLocationSelectorState.selectedLocations.concat([action.selectedLocation])
            }
        )),
    on(CentralLocationSelectorActions.setCentralLocationSelectorItemSelectAll,
        (lobbyCentralLocationSelectorState, action): LobbyCentralLocationSelectorState => (
            {
                ...lobbyCentralLocationSelectorState,
                selectedLocations: action.selectedLocations
            }
        )),
    on(CentralLocationSelectorActions.setCentralLocationSelectorItemDeSelect,
        (lobbyCentralLocationSelectorState, action): LobbyCentralLocationSelectorState => (
            {
                ...lobbyCentralLocationSelectorState,
                selectedLocations: lobbyCentralLocationSelectorState.selectedLocations.filter(l => l.locationId !== action.selectedLocation.id)
            }
        )),
    on(CentralLocationSelectorActions.setCentralLocationSelectorItemDeSelectAll,
        (lobbyCentralLocationSelectorState, action): LobbyCentralLocationSelectorState => (
            {
                ...lobbyCentralLocationSelectorState,
                selectedLocations: []
            }
        ))
);

export function lobbyCentralLocationSelectorReducer(state: LobbyCentralLocationSelectorState | undefined, action: Action) {
    return reducer(state, action);
}
